import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { SHOPPING_SORT_OPTIONS } from '../../constants';
import { SHOPPING_PRICE_OPTIONS } from '../../constants';
import ProductListDesktopNavigation from './product_list/desktop/navigation';
import ProductListMobileNavigation from './product_list/mobile/navigation';
import ProductListMobileCondendsedNav from './product_list/mobile/condensed_nav';
import MediaQuery from '../common/media_query';
import { sendAnalyticsEvent } from '../../utils/analytics';
import {find, get, pickBy, identity, capitalize, uniq} from 'lodash';

const BACKEND_CATEGORIES_UI_LABELS = {
  department: 'category',
  category: 'subcategory',
  type: 'class',
  color: 'color'
};

export default class ProductListHeader extends Component {
  constructor(props, context) {
    super(props, context);
    const {
      sort = null,
      on_sale = null,
      category = null,
      subcategory = null,
      color = null,
      colors = [],
      q = null,
      minPrice = null,
      maxPrice = null
    } = this.context.location.query;

    this.state = {
      sort,
      on_sale,
      q,
      minPrice,
      maxPrice,
      categoryFilter: category,
      subcategoryFilter: subcategory,
      classFilter: get(this.context, 'location.query.class'),
      colorFilter: color,
      colorFilters: colors,
      filterSortHidden: true
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    const {
      sort = null,
      on_sale = null,
      category = null,
      subcategory = null,
      color = null,
      q = null,
      minPrice = null,
      maxPrice = null
    } = nextContext.location.query;

    this.setState({
      sort,
      on_sale,
      q,
      minPrice,
      maxPrice,
      categoryFilter: category,
      subcategoryFilter: subcategory,
      classFilter: get(nextContext, 'location.query.class'),
      colorFilter: color
      /*
       *Adding colorFilters here breaks the functionality
       *TODO: Clean up this logic when we launch refresh
       */
    });
  }

  commaSeparatedCategories = (categories) =>
    decodeURIComponent(categories.join('%2C'));

  categoryFilters = () => {
    const commaSeparatedColors = this.commaSeparatedCategories(this.state.colorFilters);

    return ({
      category: this.state.categoryFilter,
      subcategory: this.state.subcategoryFilter,
      class: this.state.classFilter,
      //NOTE: we need colorFilter singular to not break old pages
      color: this.state.colorFilters.length ? commaSeparatedColors : this.state.colorFilter
    });
  };

  handleColorFilter = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const {
      currentTarget: {
        dataset: { id }
      }
    } = event;

    const { colorFilters } = this.state;
    const updatedColors = uniq(colorFilters.concat(id));

    this.setState({
      colorFilters: updatedColors
    });
  };

  toggleFilterAndSortVisibility = () => {
    const { filterSortHidden } = this.state;
    this.setState({ filterSortHidden: !filterSortHidden });
  };

  handleFilterAndSortClear = () => {
    const { categoryFilter, subcategoryFilter, classFilter } = this.state;
    const { productList: { isShoppingSalePage } } = this.props;
    const onSale = isShoppingSalePage ? this.state.on_sale : null;

    this.context.router.push({
      pathname: this.context.location.pathname,
      method: 'GET',
      query: pickBy({
        sort: null,
        on_sale: onSale,
        minPrice: null,
        maxPrice: null,
        category: categoryFilter,
        subcategory: subcategoryFilter,
        class: classFilter,
        color: null
      }, identity)
    });

    this.setState({
      colorFilters: [],
      colorFilter: null,
      minPrice: null,
      maxPrice: null,
      sort: null,
      on_sale: onSale
    });

    this.toggleFilterAndSortVisibility();
  };

  /*
   * For the refresh, we only make one call for multi-filtering
   * (when the update button is clicked)
   */
  handleFilterAndSortUpdate = () => {
    const { colorFilters, categoryFilter, subcategoryFilter, classFilter,
      minPrice, maxPrice, sort, on_sale, q } = this.state;
    const commaSeparatedColors = this.commaSeparatedCategories(colorFilters);

    this.context.router.push({
      pathname: this.context.location.pathname,
      method: 'GET',
      query: pickBy({
        q,
        sort,
        on_sale,
        minPrice,
        maxPrice,
        category: categoryFilter,
        subcategory: subcategoryFilter,
        class: classFilter,
        color: commaSeparatedColors
      }, identity)
    });

    this.toggleFilterAndSortVisibility();
  };

  handlePriceFilter = (event) => {
    event.preventDefault();
    const { target: { dataset: { name } } } = event;
    const selectedRange = find(SHOPPING_PRICE_OPTIONS, { name });

    let minPrice;
    let maxPrice;

    if (selectedRange) {
      minPrice = selectedRange.minPrice;
      maxPrice = selectedRange.maxPrice;
    }
    this.setState({ minPrice, maxPrice });

    sendAnalyticsEvent(
      'Shopping',
      'Filters',
      `Price - ${name}`
    );
  };

  handleSort = (event) => {
    event.preventDefault();
    const { target: { dataset: { name } } } = event;
    const { sort } = find(SHOPPING_SORT_OPTIONS, { name });

    this.setState({ sort });

    sendAnalyticsEvent(
      'Shopping',
      'Filters',
      `Sort - ${name}`
    );
  };

  handleSaleToggle = (event, inFilterSortWrapper = false) => {
    event.preventDefault();
    const { sort, on_sale, q, minPrice, maxPrice } = this.state;

    const sale = on_sale === null ? '1' : null;

    this.setState({ on_sale: sale });

    sendAnalyticsEvent(
      'Shopping',
      'Filters',
      `Sale - ${sale}`
    );

    //For a stand-alone sale checkbox (desktop & tablet), update the query immediately
    if (inFilterSortWrapper === false) {
      this.context.router.push({
        pathname: this.context.location.pathname,
        method: 'GET',
        query: pickBy({
          sort,
          q,
          'on_sale': sale,
          minPrice,
          maxPrice,
          ...this.categoryFilters()
        }, identity)
      });
    }
  };

  resetCategoryFilter = (item, id, newRouteQueryParms) => {
    const { categoryFilter } = this.state;

    if (item === 'category' && categoryFilter !== id) {
      //Reset the subcategoryFilter and classFilter if a new categoryFilter is selected
      this.setState({
        classFilter: null,
        subcategoryFilter: null,
        categoryFilter: id
      });

      newRouteQueryParms.subcategory = null;
      newRouteQueryParms.class = null;
    } else {
      this.setState({ [`${item}Filter`]: id });
    }
  };

  resetSubcategoryFilter = (item, id, newRouteQueryParms) => {
    const { subcategoryFilter } = this.state;

    if (item === 'subcategory' && subcategoryFilter !== id) {
      //Reset the classFilter if a new subcategoryFilter is selected
      this.setState({
        classFilter: null,
        subcategoryFilter: id
      });

      newRouteQueryParms.class = null;
    } else {
      this.setState({ [`${item}Filter`]: id });
    }
  };

  //Used for category, subcategory & class
  handleFilter = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const { isBrandOrRetailerPage } = this.props.productList;
    const {
      currentTarget: {
        href,
        text: name,
        dataset: { label, id }
      }
    } = event;

    const item = BACKEND_CATEGORIES_UI_LABELS[label];

    //On category list pages, reroute instead of adding 'category' to the query params
    if ((label === 'department' || label === 'collection') && !isBrandOrRetailerPage) {
      return this.context.router.push({
        pathname: href,
        method: 'GET'
      });
    }

    const { sort, on_sale, q, minPrice, maxPrice } = this.state;

    const newRouteQueryParms = {
      sort,
      on_sale,
      q,
      minPrice,
      maxPrice,
      ...this.categoryFilters(),
      [item]: id
    };

    //Reset the category query param on brand / retailer pages
    if (isBrandOrRetailerPage) {
      this.resetCategoryFilter(item, id, newRouteQueryParms);
    //on category list pages
    } else {
      this.resetSubcategoryFilter(item, id, newRouteQueryParms);
    }

    this.context.router.push({
      pathname: this.context.location.pathname,
      method: 'GET',
      query: pickBy({ ...newRouteQueryParms }, identity)
    });

    if (id) {
      sendAnalyticsEvent(
        'Shopping',
        'Filters',
        `${capitalize(item)} - ${name}`
      );
    }
  };

  render() {
    const { sort, on_sale, minPrice, maxPrice, categoryFilter, subcategoryFilter,
      classFilter, colorFilters, filterSortHidden } = this.state;
    const { name } = find(SHOPPING_SORT_OPTIONS, { sort });
    const { isShoppingHome, isShoppingCollectionPageHome } = this.props.productList;

    let selectedPriceRange;
    if (minPrice) {
      selectedPriceRange = find(SHOPPING_PRICE_OPTIONS, { minPrice: minPrice });
    }

    const desktopNavigation = (
      <ProductListDesktopNavigation {...this.props}
        sort={name}
        on_sale={on_sale}
        categoryFilter={categoryFilter}
        subcategoryFilter={subcategoryFilter}
        classFilter={classFilter}
        colorFilters={colorFilters}
        selectedPriceRange={selectedPriceRange}
        handleSort={this.handleSort}
        handleColorFilter={this.handleColorFilter}
        handlePriceFilter={this.handlePriceFilter}
        handleSaleToggle={this.handleSaleToggle}
        handleFilter={this.handleFilter}
        handleFilterAndSortUpdate={this.handleFilterAndSortUpdate}
        handleFilterAndSortClear={this.handleFilterAndSortClear}
        minPrice={minPrice}
        maxPrice={maxPrice}
        filterSortHidden={filterSortHidden}
        toggleFilterAndSort={this.toggleFilterAndSortVisibility}
      />
    );

    const tabletNavigation = isShoppingHome || isShoppingCollectionPageHome
      ? <ProductListMobileCondendsedNav {...this.props} />
      : desktopNavigation;

    const mobileNavigation = isShoppingHome || isShoppingCollectionPageHome
      ? <ProductListMobileCondendsedNav {...this.props} />
      : (
        <ProductListMobileNavigation {...this.props}
          handleFilterAndSortUpdate={this.handleFilterAndSortUpdate}
          handleFilterAndSortClear={this.handleFilterAndSortClear}
          handleColorFilter={this.handleColorFilter}
          handleSaleToggle={this.handleSaleToggle}
          handlePriceFilter={this.handlePriceFilter}
          handleSort={this.handleSort}
          handleFilter={this.handleFilter}
          colorFilters={colorFilters}
          on_sale={on_sale}
          selectedPriceRange={selectedPriceRange}
          minPrice={minPrice}
          maxPrice={maxPrice}
          sort={name}
          filterSortHidden={filterSortHidden}
          toggleFilterAndSort={this.toggleFilterAndSortVisibility}
          categoryFilter={categoryFilter}
          subcategoryFilter={subcategoryFilter}
          classFilter={classFilter}
        />
      );

    return (
      <div>
        <MediaQuery breakpoint="desktop">
          {desktopNavigation}
        </MediaQuery>
        <MediaQuery breakpoint="tablet">
          {tabletNavigation}
        </MediaQuery>
        <MediaQuery breakpoint="mobile">
          {mobileNavigation}
        </MediaQuery>
      </div>
    );
  }
}

ProductListHeader.propTypes = {
  shoppingNavigationItems: PropTypes.shape({
    subcategories: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        path: PropTypes.string,
        name: PropTypes.string
      })
    ),
    colors: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string
      })
    )
  }).isRequired,
  productList: PropTypes.shape({
    isShoppingHome: PropTypes.bool,
    isBrandOrRetailerPage: PropTypes.bool.isRequired,
    isShoppingCollectionPageHome: PropTypes.bool,
    isShoppingSalePage: PropTypes.bool
  })
};

ProductListHeader.contextTypes = {
  location: PropTypes.object,
  router: PropTypes.object
};
